<template>
  <div class="card shadow-sm rounded-5 text-center" :class="color">
    <TrophyIcon v-if="isTopGroup" />
    <div class="card-header">
      <GroupIcon :index="index" :width="100" />
      <div class="fs-3 fw-bold">{{ name }}</div>
    </div>
    <div class="card-body p-5 d-flex justify-content-center">
      <StarIcon :points="points" :color="color" />
    </div>
  </div>
</template>

<script>
import GroupIcon from "@/components/activity/GroupIcon.vue";
import TrophyIcon from "@/components/activity/TrophyIcon.vue";
import StarIcon from "@/components/activity/StarIcon.vue";

// Data
export default {
  name: "GroupCard",
  components: { GroupIcon, TrophyIcon, StarIcon },
  props: {
    id: {
      type: Number,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    points: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    isTopGroup: {
      type: Boolean,
      default: false
    }
  }
};
</script>
